import React from "react";
import { useImmer } from "use-immer";

import { SxProps, TypographyVariant, useTheme } from "@mui/material";

import { IgTooltip } from "./IgTooltip";
import { IgTypography } from "./IgTypography";

interface IgTypographyTooltipProps {
  textWidth?: string;
  textMaxWidth?: string;
  text: string;
  textSx?: SxProps;
  noHover?: boolean;
  variant?: TypographyVariant | "body3";
  differentTooltipText?: string;
}
export const IgTypographyTooltip = ({
  text,
  textMaxWidth,
  textSx,
  noHover,
  variant,
  differentTooltipText,
}: IgTypographyTooltipProps) => {
  const [showTooltip, setShowTooltip] = useImmer(false);
  const theme = useTheme();
  return (
    <IgTooltip title={showTooltip ? differentTooltipText || text : ""}>
      <IgTypography
        noWrap={true}
        onMouseOver={(e) => {
          if (e.currentTarget.scrollWidth > e.currentTarget.clientWidth) {
            setShowTooltip((draft) => {
              draft = true;
              return draft;
            });
          }
        }}
        onMouseOut={() => {
          setShowTooltip(false);
        }}
        variant={variant || "h3"}
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "block",
          fontWeight: 600,
          maxWidth: textMaxWidth ?? "100%",
          // width: textWidth ?? "250px",
          "&:hover": {
            cursor: noHover ? "default" : "pointer",
            color: noHover
              ? "inherit"
              : theme.palette.text.interactive.neutral.hover,
          },
          ...textSx,
        }}
      >
        {text}
      </IgTypography>
    </IgTooltip>
  );
};
